// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TabList_wrap__1KdiW"};